module.exports = __webpack_public_path__ + "img/icon_user.a7f272e9.svg";